import { MunicipalityUpdateInput } from '@libs/types/src/list/input-type/municipality.update-input';
import { MunicipalityCreateInput } from '@libs/types/src/list/input-type/municipality.create-input';
import { MunicipalityGridObject, MunicipalityObject } from '@libs/types/src/list/object-type/municipality.object';
import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { GqlServiceV2 } from '../../modules/content/service/gql.service-v2';
import { filterFrag } from '../types/filter.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { municipalityFrag } from '../types/municipality.types';

@Injectable({ providedIn: 'root' })
export class ListMunicipalityService extends GqlServiceV2 {

    public getListMunicipalities(input: GridInput, frag = municipalityFrag) {
        return this.query<MunicipalityGridObject>(
            `
                query($input: GridInput!) {
                    municipality {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createListMunicipality(input: MunicipalityCreateInput, frag = municipalityFrag) {
        return this.mutate<MunicipalityObject>(
            `
                mutation($input: MunicipalityCreateInput!) {
                    municipality {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateListMunicipality(input: MunicipalityUpdateInput, frag = municipalityFrag) {
        return this.mutate<MunicipalityObject>(
            `
                mutation($input: MunicipalityUpdateInput!) {
                    municipality {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteListMunicipality(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    municipality {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

}
